<template>
  <div
    v-if="rows && rows.length > 0"
    class="mt-4 space-y-4 text-sm sm:text-base bg-white rounded-lg shadow-sm p-4 sm:p-5"
  >
    <p
      v-if="seriesCaption"
      class="text-xs sm:text-sm text-gray-500"
    >
      {{ seriesCaption }}
    </p>
    <div class="overflow-x-auto -mx-1 px-1">
      <table class="w-full min-w-[32rem] text-left border-collapse">
        <thead>
          <tr class="border-b border-gray-200 text-gray-500">
            <th class="py-2 pr-3 font-medium">
              {{ $t('BoxPlotStatsSection.columnArea') }}
            </th>
            <th class="py-2 pr-3 font-medium whitespace-nowrap">
              {{ $t('BoxPlotStatsSection.columnMean') }}
            </th>
            <th class="py-2 pr-3 font-medium">
              {{ $t('BoxPlotStatsSection.columnMedian') }}
            </th>
            <th class="py-2 pr-3 font-medium whitespace-nowrap">
              {{ $t('BoxPlotStatsSection.columnSigma') }}
            </th>
            <th class="py-2 font-medium">
              {{ $t('BoxPlotStatsSection.columnSpread') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(row, idx) in rows"
            :key="idx"
            class="border-b border-gray-100 last:border-b-0"
          >
            <td class="py-2.5 pr-3 font-semibold text-gray-800 align-top">
              {{ row.label }}
            </td>
            <td class="py-2.5 pr-3 font-semibold text-gray-800 whitespace-nowrap">
              {{ formatNum(row.mean) }}
            </td>
            <td class="py-2.5 pr-3 text-gray-600 whitespace-nowrap">
              {{ formatNum(row.median) }}
            </td>
            <td class="py-2.5 pr-3 text-gray-600 whitespace-nowrap">
              {{ formatNum(row.sd) }}
            </td>
            <td class="py-2.5 text-gray-600">
              {{ $t(`BoxPlotStatsSection.spread${capitalize(row.spreadKey)}`) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <ul class="list-disc list-inside text-xs sm:text-sm text-gray-500 space-y-1.5 pt-1">
      <li>{{ $t('BoxPlotStatsSection.legendBoxQuartiles') }}</li>
      <li>{{ $t('BoxPlotStatsSection.legendMedianLine') }}</li>
      <li>{{ $t('BoxPlotStatsSection.legendMeanDot') }}</li>
      <li>{{ $t('BoxPlotStatsSection.legendWhiskers') }}</li>
      <li>{{ $t('BoxPlotStatsSection.legendSigmaExplainer') }}</li>
    </ul>
  </div>
</template>

<script setup>
import { formatOwnResultNumber } from '@/helpers/formatOwnResultNumber';

defineProps({
  /** Rows from buildBoxplotStatsRows */
  rows: { type: Array, default: () => [] },
  /** Optional line under title, e.g. selected series when comparing */
  seriesCaption: { type: String, default: '' },
});

function formatNum(v) {
  return formatOwnResultNumber(v);
}

function capitalize(s) {
  if (!s || typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
}
</script>
